import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "footer-area pt-100 pb-75" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col-lg-4",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_5 = { class: "footer-single-widget mw-250" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "ps-0 mb-0 list-unstyled d-flex social-links" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = ["href"]
const _hoisted_14 = { key: 3 }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "col-lg-8" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = {
  class: "col-xl-3 col-sm-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_19 = { class: "footer-single-widget" }
const _hoisted_20 = { class: "ps-0 mb-0 list-unstyled import-links" }
const _hoisted_21 = {
  class: "col-xl-3 col-sm-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "300"
}
const _hoisted_22 = { class: "footer-single-widget" }
const _hoisted_23 = { class: "ps-0 mb-0 list-unstyled import-links" }
const _hoisted_24 = {
  class: "col-xl-3 col-sm-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "400"
}
const _hoisted_25 = { class: "footer-single-widget" }
const _hoisted_26 = { class: "ps-0 mb-0 list-unstyled contact-links" }
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "mb-0" }
const _hoisted_29 = { class: "footer-compliance" }
const _hoisted_30 = { class: "fc-pay" }
const _hoisted_31 = { class: "fc-secure" }
const _hoisted_32 = { class: "fc-legal" }
const _hoisted_33 = {
  key: 0,
  class: "fc-addr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_CardMarks = _resolveComponent("CardMarks")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_RouterLink, {
              to: "/",
              class: "d-inline-block footer-logo"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _ctx.footer.logo_url || _ctx.defaultLogo,
                  alt: "logo"
                }, null, 8, _hoisted_6)
              ]),
              _: 1
            }),
            _createElementVNode("p", null, _toDisplayString(_ctx.footer.description), 1),
            _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Social Media", -1)),
            _createElementVNode("ul", _hoisted_7, [
              (_ctx.footer.facebook_url)
                ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                    _createElementVNode("a", {
                      href: _ctx.footer.facebook_url,
                      target: "_blank",
                      rel: "noopener"
                    }, _cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "ri-facebook-fill" }, null, -1)
                    ]), 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.footer.twitter_url)
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _createElementVNode("a", {
                      href: _ctx.footer.twitter_url,
                      target: "_blank",
                      rel: "noopener"
                    }, _cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "ri-twitter-x-fill" }, null, -1)
                    ]), 8, _hoisted_11)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.footer.instagram_url)
                ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                    _createElementVNode("a", {
                      href: _ctx.footer.instagram_url,
                      target: "_blank",
                      rel: "noopener"
                    }, _cache[2] || (_cache[2] = [
                      _createElementVNode("i", { class: "ri-instagram-fill" }, null, -1)
                    ]), 8, _hoisted_13)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.footer.linkedin_url)
                ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                    _createElementVNode("a", {
                      href: _ctx.footer.linkedin_url,
                      target: "_blank",
                      rel: "noopener"
                    }, _cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "ri-linkedin-fill" }, null, -1)
                    ]), 8, _hoisted_15)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Services", -1)),
                _createElementVNode("ul", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footer.service_links, (link) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: link.url
                    }, [
                      _createVNode(_component_RouterLink, {
                        to: link.url
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(link.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Company", -1)),
                _createElementVNode("ul", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footer.company_links, (link) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: link.url
                    }, [
                      _createVNode(_component_RouterLink, {
                        to: link.url
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(link.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Get In Touch", -1)),
                _createElementVNode("ul", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footer.contact, (c) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: c.phone
                    }, [
                      _createElementVNode("a", {
                        href: 'tel:' + c.phone
                      }, _toDisplayString(c.phone), 9, _hoisted_27),
                      _createElementVNode("p", _hoisted_28, _toDisplayString(c.note), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_CardMarks),
          _createElementVNode("span", _hoisted_31, [
            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "ti ti-lock" }, null, -1)),
            _createTextVNode(" Secure checkout · Prices in " + _toDisplayString(_ctx.company.payments.currency), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_RouterLink, { to: "/terms-conditions" }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("Terms")
            ])),
            _: 1
          }),
          _createVNode(_component_RouterLink, { to: "/refund-policy" }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("Refunds")
            ])),
            _: 1
          }),
          _createVNode(_component_RouterLink, { to: "/privacy-policy" }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("Privacy")
            ])),
            _: 1
          })
        ]),
        (_ctx.address)
          ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.company.legalName) + " · " + _toDisplayString(_ctx.address), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}